import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { interval } from 'rxjs';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
declare var $: any;


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BaseClass<any> implements OnInit {
  public data: any;
  //public casinoData: any;
  public homeData: any;
  public inPlayData: any;
  public listRes: any;
  public marketsReq: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public oddsLisDisNew: any = {};
  public exposLisDis: any = {};
  public newOddsEnable: boolean = false;
  public marketData: any;
  public tabId: any = 'in_play';
  public tabSet: any;

  public menuItems: any[] = [];
  public id: any;
  public userDataGot: boolean = false;
  public hRaceList: any[] = [];
  public gRaceList: any[] = [];

  constructor(
    public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    public actRoute: ActivatedRoute,
    public router: Router,
  ) {
    super();
    this.constructorCallData();
  }

  constructorCallData() {
    //emit value in sequence every given second\
    const sub2 = interval(this.env.pollers.listOddsData).subscribe(val => {
      if (this.webSocketUrl != '') {
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.marketData);
        } else {
          this.getOdds(this.marketsReq);
        }
      }
    });
    this.subs.push(sub2);

    const sub3 = this._shared.sharedSideMenu.subscribe((data: any) => {
      //console.log("kkkk");
      //console.log(data);
      if (data && data?.menuAPICall) {
        this.menu = this.getLocalItem('menu');
        this.setMenu();
      }

    });
    this.subs.push(sub3);
  }

  ngOnInit(): void {
    this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
    if (this.menu != null && this.menu.length > 0) {
      this.setMenu();
    }

    // Topnav inplay counter
    let sideRaceM7 = (localStorage.getItem(`${this.env.panel}sideRaceMenu7`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu7`) as any) : [];
    let sideRaceM4339 = (localStorage.getItem(`${this.env.panel}sideRaceMenu4339`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu4339`) as any) : [];
    let hUpCommingRaceCount = this.findUpComingRace(sideRaceM7, 7).length;
    let gUpCommingRaceCount = this.findUpComingRace(sideRaceM4339, 4339).length;
    this.menu.forEach((menuEle: any, i: any) => {
      menuEle['in_play_count'] = 0;
      if (this.events.races.includes(menuEle.id)) {
        menuEle['in_play_count'] = (menuEle.id === 7) ? hUpCommingRaceCount : gUpCommingRaceCount;
      } else if (this.events.sports.includes(menuEle.id)) {
        menuEle['in_play_count'] = this.getEventInplayDataCount(menuEle.id);
      }
    });
  }

  getEventInplayDataCount(event_type_id: any) {
    let sideM = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    const groupedInPlay = this.groupBy(sideM, (dat: any) => dat.in_play);
    //const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);
    //let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]
    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : []]
    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });
    const groupedCat = this.groupBy(uniqueArray, (dat: any) => dat.event_type_id);
    let inPlayEventTypeData = groupedCat.get(event_type_id) ? groupedCat.get(event_type_id) : [];

    return inPlayEventTypeData.length;
  }

  setMenu() {
    if (this.actRoute.snapshot.paramMap.get('id')) {

      this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
      this.menu.forEach((element: any, i: number) => {
        if (this.actRoute.snapshot.paramMap.get('id')?.includes(element.id)) {
          this.menuItems = [element];
          this.tabId = element.id;
        }
      });

      if (this.events.races.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
        //this.getRaceListData(this.actRoute.snapshot.paramMap.get('id'));
        if (this.data) { } else { this.getData(); }
      } else if (!this.events.casino.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
        if (this.data) { } else { this.getData(); }
      }

    } else {
      this.menuItems = this.menu;
      this.menuItems.unshift({ id: 'in_play', name: 'Watch Live' }, { id: 'virtual_cricket', name: 'Virtual Cricket' })
      this.menuItems.push({ id: 'multi', name: 'multi markets' });
      this.menuItems = this.menuItems.map((item:any) => {
        item.name = item.name.replace(" Racing", ""); // Replace " Racing" with an empty string
        return item;
      });
      if (!this.events.casino.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
        if (this.data) { } else { this.getData(); }
      }
    }
  }


  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.isLoad = true;
    this.data = undefined;
    this.homeData = undefined;
    this.inPlayData = undefined;
    let url = this.isLogin() ? this.api.eventListNew : this.api.eventListNewG;

    this.getServices().Get(`${this.env.baseUrl + url}`).subscribe(
      (res: any) => {
        if (res.status == true) {
          // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
          this.listRes = res.data;
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
          this.setRaceSideMenu(7, res.data.races);
          this.setRaceSideMenu(4339, res.data.races);
          res.data.races.forEach((element: any) => {
            element['in_play'] = 1;
          });
          let events = [...res.data.events, ...res.data.races];

          this.hRaceList = this.findUpComingRace(res.data.races, 7);
          this.gRaceList = this.findUpComingRace(res.data.races, 4339);

          this.commonLogics(res, events);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setRaceSideMenu(id: any, items: any) {
    let dt = items.filter((s: any) => { return Number(s.event_type_id) == Number(id) });
    this.setLocalItem(`sideRaceMenu${id}`, dt);
    this._shared.emitSideMenu(dt);
  }

  // getRaceListData(id: any) {
  //   this.isLoad = true;
  //   this.data = undefined;
  //   this.homeData = undefined;
  //   this.inPlayData = undefined;

  //   let url = this.getToken() ? this.api.raceList : this.api.raceListG;
  //   this.getServices().Get(`${this.env.baseUrl + url}/${id}`).subscribe(
  //     (res) => {
  //       if (res.status == true) {
  //         this.setLocalItem(`sideRaceMenu${id}`, res?.data?.race);
  //         this._shared.emitSideMenu(res?.data?.race);
  //         res.data.race.forEach((element: any) => {
  //           element['in_play'] = 1;
  //           element['event_type_id'] = Number(id);
  //         });
  //         this.commonLogics(res, res?.data?.race);

  //       } else {
  //         this._common.checkForForceChangePassword(res);
  //       }
  //     },
  //     (err) => {
  //       console.log(err);
  //     });
  // }

  commonLogics(res: any, events: any) {
    this.webSocketUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
    // this.setLocalItem('wsu', this.webSocketUrl);
    this.setLocalItem('ws', this.webSocketUrl, false);
    events = this.UTC_to_Local_timeZone(events);
    this.marketsReq = this.genMarketReq(events);

    this.marketData = res?.data;
    this.data = events;
    this.homeData = this.getHomeData(events);
    this.inPlayData = this.getInplayData(events);
    this.isLoad = false;
    if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
      this.newOddsEnable = true;
      this.getOddsNew(this.marketsReq, res?.data);
    } else {
      this.newOddsEnable = false;
      this.getOdds(this.marketsReq);
    }
    // this.getExposure(this.marketsReq);

  }

  getOdds(req: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.odds}`, req).subscribe(
      (res) => {
        res = this.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getOddsNew(req: any, resData: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this.pipe_string_to_JSON(res);
        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);

        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.oddsLisDis = this.oddsLisDisNew;

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getExposure(req: any) {
    this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          res = res.data.exposes;
          // res = this.string_to_JSON(res);

          res.forEach((element: any) => {
            this.exposLisDis[element?.marketId ? element?.marketId : element?.market_id] = element;
          });
        }
      },
      (err) => {
        console.log(err);
      });
  }

  genMarketReq(res: any) {
    let market: any[] = [];
    res.forEach((element: any) => {
      market.push('market_ids[]=' + encodeURIComponent(element.market_id));
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];

    return market.join('&') as any;
  }

  onSelect(data: any): void {
    // this.data = undefined;
    this.tabId = data.id;
    if (this.events.races.includes(data.id)) {
      // this.isLoad = true;
      // this.getRaceListData(data.id);
    } else if (!this.events.casino.includes(data.id)) {
      // this.getData();
    }
  }

  getHomeData(data: any) {
    const groupedInPlay = this.groupBy(data, (dat: any) => dat.in_play);
    const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);

    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]

    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    return uniqueArray;
  }

  getInplayData(data: any) {
    const groupedInPlay = this.groupBy(data, (dat: any) => dat.in_play);
    //const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);

    //let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]
    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : []]

    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    // const groupedCat = this.groupBy(uniqueArray, (dat: any) => dat.event_type_id);
    // var cricketEvents = groupedCat.get(4) ? groupedCat.get(4) : [];
    // var otherEvents = uniqueArray.filter((e:any) => { return (e.event_type_id != 4)})
    // const inplay = [...cricketEvents, ...otherEvents];

    return uniqueArray;
  }

  ngDoCheck() {
    if (this.id && this.id != this.actRoute.snapshot.paramMap.get('id')) {
      this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
      this.setMenu();
    }

    if (this.menu == null || this.menu.length == 0) {

      this.menu = this.getLocalItem('menu') ? this.getLocalItem('menu', true) : [];
      if (this.menu.length > 0) {
        this.setMenu();
      }

    }
  }

  ngAfterViewInit() {
    const myCarousel = document.querySelector('#DashSlider');
    const carousel = $(myCarousel).carousel();
  }


  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
